import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { useUserUid } from '../../hooks/useUserUid';

import { envSwitch } from '@/utils/environmentUtils';

const applicationId = '2d52a226-3d6c-4ec8-859f-b77a33b29011';
const clientToken = 'pub0659587cdce54a0ed4687e965b49cf45';

const CORTEX_URL = envSwitch({
  local: 'http://localhost:8000',
  dev: 'https://cortex.bighealthdev.com',
  qa: 'https://cortex.bighealthdev.com',
  pr: 'https://cortex.bighealthdev.com',
  stage: 'https://cortex.bighealthstage.com',
  prod: 'https://cortex.bighealth.com',
});

const VAF_URL = envSwitch({
  local: 'https://vercel-auth-functions-lower.vercel.app',
  dev: 'https://vercel-auth-functions-lower.vercel.app',
  qa: 'https://vercel-auth-functions-lower.vercel.app',
  pr: 'https://vercel-auth-functions-lower.vercel.app',
  stage: 'https://vercel-auth-functions-stage.vercel.app',
  prod: 'https://vercel-auth-functions-prod.vercel.app',
});

const SUPABASE_URL = envSwitch({
  local: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  dev: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  qa: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  pr: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  stage: 'https://ngxdbhvvxledqxykuwpr.supabase.co',
  prod: 'https://evwudmabosoioeqpdbii.supabase.co',
});

// Entropy URL pattern inferred from Vercel project names — verify before shipping
const ENTROPY_URL = envSwitch({
  local: 'https://entropy-lower.vercel.app',
  dev: 'https://entropy-lower.vercel.app',
  qa: 'https://entropy-lower.vercel.app',
  pr: 'https://entropy-lower.vercel.app',
  stage: 'https://entropy-stage.vercel.app',
  prod: 'https://entropy-prod.vercel.app',
});

if (process.env.NODE_ENV !== 'development') {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'cap',
    env: process.env.REACT_APP_DEPLOY_ENV,
    version: process.env.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: (url: string) => url.startsWith(window.location.origin), propagatorTypes: ['tracecontext', 'datadog'] },
      { match: (url: string) => url.startsWith(CORTEX_URL), propagatorTypes: ['tracecontext', 'datadog'] },
      { match: (url: string) => url.startsWith(VAF_URL), propagatorTypes: ['tracecontext', 'datadog'] },
      { match: (url: string) => url.startsWith(SUPABASE_URL), propagatorTypes: ['tracecontext', 'datadog'] },
      { match: (url: string) => url.startsWith(ENTROPY_URL), propagatorTypes: ['tracecontext', 'datadog'] },
    ],
    plugins: [reactPlugin({ router: false })],
  });
}

const DatadogInit: React.FC = () => {
  const { userUid } = useUserUid();

  useEffect(() => {
    if (userUid) {
      datadogRum.setUser({ id: userUid });
    } else {
      datadogRum.clearUser();
    }
  }, [userUid]);

  return null;
};

export default DatadogInit;
